/**
 * awsInstancePrice模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const awsPrice = {
  // 查询AWS EC2 价格
  queryAWSInstancePrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAWSPrice/queryAWSInstancePrice`,params);
  },
  // 查询AWSvpc价格
  queryAWSVPCPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAWSPrice/queryAWSVPCPrice`,params);
  },
  // 查询AWSS3价格
  queryAWSS3Price(params) {
    return $http.post(`${global.API_URL}/sme/ceAWSPrice/queryAWSS3Price`,params);
  },
  // 查询AWS数据库价格
  queryAWSRDSPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAWSPrice/queryAWSRDSPrice`,params);
  },
  // 查询AWS弹性IP价格
  queryAWSEipPrice(params) {
    return $http.post(`${global.API_URL}/sme/ceAWSPrice/queryAWSEipPrice`,params);
  }
}

export default awsPrice;



// WEBPACK FOOTER //
// ./src/api/awsPrice.js